import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import React, { useState, useRef, useEffect } from "react";
import BASE_URL from "components/BaseUrl/apiConfig";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Swal from "sweetalert2";

const ChangePassword = () => {
  const history = useHistory();
  const userNameInputRef = useRef(null);
  useEffect(() => {
    // Check if user is not logged in (localStorage is empty)
    if (!localStorage.getItem("userData")) {
      // Redirect to the login page
      history.push("/login");
    }
  }, [history]);

  const [formData, setFormData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [validationErrors, setValidationErrors] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [response_api, setResonse_api] = useState("");

  useEffect(() => {
    // Focus on the userName input when the component mounts
    userNameInputRef.current.focus();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", // Clear the validation error when the user types
    }));
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    // Perform validation logic for each field
    if (formData.oldPassword.trim() === "") {
      newErrors.oldPassword = "Old Password is required.";
      isValid = false;
    }

    if (formData.newPassword.trim() === "") {
      newErrors.newPassword = "New Password is required.";
      isValid = false;
    }

    if (formData.confirmPassword.trim() === "") {
      newErrors.confirmPassword = "Confirmation Password is required.";
      isValid = false;
    } else if (formData.newPassword !== formData.confirmPassword) {
      newErrors.confirmPassword = "Confirmation do not match new password.";
      isValid = false;
    }

    setValidationErrors(newErrors);
    return isValid;
  };

  const handleChangePassword = async () => {
    // Validate the form before making the API call
    if (!validateForm()) {
      return;
    }

    const storedUserData = localStorage.getItem("userData");
    let userName = "";
    if (storedUserData) {
      const userData = JSON.parse(storedUserData);
      userName = userData.userName;
    }

    try {
      const response = await fetch(`${BASE_URL}/api/Users/UpdatePassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userName,
          password: formData.oldPassword,
          confirmPassword: formData.newPassword,
        }),
      });

      if (response.ok) {
        const data = await response.json();

        // Show SweetAlert success message
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.msg,
        });

        setFormData({
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
      } else {
        const errorData = await response.json();

        if (errorData.msg === "Old password is not correct.    ") {
          // Show SweetAlert error message
          Swal.fire({
            icon: "error",
            title: "Something went wrong.",
            text: errorData.msg,
          });
        } else {
          // Show SweetAlert error message
          Swal.fire({
            icon: "error",
            title: "Error",
            text: errorData.msg,
          });
        }
      }
    } catch (error) {
      console.error("Error during password change:", error);
      // Show SweetAlert error message for unexpected errors
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An unexpected error occurred. Please try again later.",
      });
    }
  };

  return (
    <>
      <Navbar />
      <div className="container mx-auto p-4 min-h-content-minvh">
        <div className="flex content-center items-center justify-center h-full">
          <div className="w-full lg:w-6/12 px-4">
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
              <div className="rounded-t mb-0 px-6 py-6">
                <div className="text-center mb-3">
                  <h1 className="text-2xl font-bold">Change Password</h1>
                </div>
                <p
                  className={
                    response_api === "Password updated successfully"
                      ? "text-red-500 text-xs mt-1"
                      : "text-red-500 text-xs mt-1"
                  }
                >
                  {response_api}
                </p>

                {/* <hr className="mt-6 border-b-1 border-blueGray-300" /> */}
              </div>
              <div className="flex-auto px-4 lg:px-10 py-3 pt-0">
                <form>
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="oldPassword"
                    >
                      Old Password
                    </label>
                    <input
                      type="password"
                      name="oldPassword"
                      ref={userNameInputRef}
                      maxLength={30}
                      value={formData.oldPassword}
                      onChange={handleChange}
                      className=" border rounded w-full"
                      placeholder="Enter old password"
                    />
                    <p className="text-red-500 text-xs mt-1">
                      {validationErrors.oldPassword}
                    </p>
                  </div>

                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="newPassword"
                    >
                      New Password
                    </label>
                    <input
                      type="password"
                      name="newPassword"
                      maxLength={30}
                      value={formData.newPassword}
                      onChange={handleChange}
                      className="border rounded w-full"
                      placeholder="Enter new password"
                    />
                    <p className="text-red-500 text-xs mt-1">
                      {validationErrors.newPassword}
                    </p>
                  </div>

                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="confirmPassword"
                    >
                      Confirmation Password
                    </label>
                    <input
                      type="password"
                      name="confirmPassword"
                      maxLength={30}
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      className="border rounded w-full"
                      placeholder="Enter confirmation password"
                    />
                    <p className="text-red-500 text-xs mt-1">
                      {validationErrors.confirmPassword}
                    </p>
                  </div>

                  <div className="text-center mt-6">
                    <button
                      className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                      type="button"
                      onClick={handleChangePassword}
                    >
                      Change Password
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ChangePassword;
